import { useMutation, useQuery, useQueryClient } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useMyWorkDisplaySettings = (enabled = true) => {
  return useQuery({
    queryKey: "my-work-display-settings",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/users/my-work-display-settings`,
        signal,
      }),
    enabled,
  });
};

export const useMyWorkDisplaySettingsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/users/my-work-display-settings`,
        method: "PUT",
        body: data,
      }),
    onSuccess: (response) => {
      queryClient.setQueryData("my-work-display-settings", response);
    },
  });
};
